import Debug from 'debug';
import { createUpserter } from '@/app/shared/utils'
import { UpdateBadgesStateCommand } from './update-badges-state-command';
import { BadgeState, defaultBadgeState } from './badge-state';

export type BadgeReducerCommand = UpdateBadgesStateCommand;

const upsert = createUpserter<BadgeState>((id) => defaultBadgeState(id));

const debug = Debug('badge-state-reducer');

export function badgeStateReducer(state: BadgeState[], command: BadgeReducerCommand) {
  switch (command.name) {
    case 'update-badges-state':
      const payload = command.payload;
      debug('executing update-badges-state', command.payload);
      let newState: BadgeState[] = state;
      for (const item of payload) {
        newState = upsert(newState, item.id, (_current) => {
          const merged: BadgeState =
                item.status === 'earned' ? {
                  ...item,
                  date: item.date
                } : {
                  ...item
                };

          return merged;
        });
      }

      debug('new state after update-badges-state', newState);
      return newState;
  }
}
